import React from 'react';
import { createRoot } from 'react-dom/client';

import Root from 'src/boot/Root';

const container = document.getElementById('app');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);
root.render(<Root />);
